"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orders_addons = exports.order_item = exports.orders = exports.order = void 0;
exports.order = "/api/orders/{id}";
exports.orders = "/api/orders{?page,per_page,order_by,order_direction,customer_id,vendor_id,utm_source,le_label,le_attribution,updated_since,booking_numbers,remove_addons,status}";
exports.order_item = "/api/orders/{order_id}/items/{id}";
exports.orders_addons = "/api/orders/addons/{addon_opportunity_id}";
